export * from './capitalizeText';
export * from './isArraysEquals';
export * from './yandexMapLink';
export * from './formatNumber';
export * from './getPluralForm';
export * from './getPluralWord';
export * from './handleErrorToast';
export * from './formatLikes';
export * from './formatAnyPhoneNumber';
export * from './dayPluralForm';
export * from './yandexMetrika';
export * from './shareData';
